<template>
  <BaseButton type="button" primary class="flex items-center space-x-2" @click="showUploadDialog">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
      />
    </svg>
    <span class="inline-block">Upload</span>
  </BaseButton>
</template>

<script>
import { mediaLibraryMediaClient } from '@/api/clients/admin';

export default {
  methods: {
    uploadFiles(data) {
      return mediaLibraryMediaClient.store(data).then(() => {
        this.$emit('upload-completed');
      });
    },
    showUploadDialog() {
      this.$modal.show({
        component: () => import('Components/MediaLibrary/UploadFilesDialog.vue'),
        props: {
          action: this.uploadFiles,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
